// extracted by mini-css-extract-plugin
module.exports = {"signCanvas":"signCanvas_signCanvas__3ehGX"};